<template>
  <div class="card">
    <div class="card-header pb-0">
      <h6>Productos Xhantae</h6> 
      <div class="row">
        <div class="col-sm-8 w-80"></div>
        <select name="custom-select" v-model="selectedDate"
        @change="handleSelected"
        class="form-control col-md-2 w-20" id="custom-select">
          <option disabled value="">Seleccione una fecha</option>
          <option v-for="date in dates" v-bind:key="date" :value="date">{{ date }}</option>
        </select>
      </div>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <div class="table-responsive p-0">
        <table class="table align-items-center mb-0">
          <thead>
            <tr>
              <th v-for="header in headers" v-bind:key="header.text"
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >{{ header.text }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="product in displayItems" v-bind:key="product.id">
              <td class="align-middle text-center">
                <div v-for="variant in product.variants" v-bind:key="variant"
                 class="d-flex flex-column justify-content-center">{{ variant.sku }}</div>
              </td>
              <td class="align-middle text-center text-sm">
                <span class="badge badge-sm bg-gradient-success">{{ product.status }}</span>
              </td>
              <td><span class="text-secondary text-xs text-center font-weight-bold">{{ product.title }}</span></td>
              <td>
                <div v-for="variant in product.variants" v-bind:key="variant"
                 class="text-center text-sm justify-content-between">
                  ${{ variant.price }}</div>
              </td>
              <td>
                <div v-for="variant in product.variants" v-bind:key="variant"
                 class="text-center text-sm justify-content-between">
                  {{ variant.inventory_quantity }}</div>
              </td>
              <td>
                <div v-for="variant in product.variants" v-bind:key="variant"
                 class="text-center text-sm justify-content-between">
                  {{ variant.old_inventory_quantity }}</div>
              </td>
              <td class="text-center"><span class="text-secondary text-xs font-weight-bold">{{ formatDate(product.created_at) }}</span></td>
              <td class="text-center"><span class="text-secondary text-xs font-weight-bold">{{ formatDate(product.updated_at) }}</span></td>
              <td class="text-center">
                <div class="d-flex px-2 py-1 justify-content-center">
                  <div>
                   <img class="avatar avatar-sm me-3" :src="product.image ? product.image.src : require('@/assets/img/image_not_available.jpg')" 
                    :alt="product.image ? product.image.alt : 'not-available'">
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="d-flex justify-content-center p-4 my-2 align-items-center" v-if="displayItems.length <= 0">
          <span class="text-dark font-weight-bold">No hay nuevas actualizaciones.....</span>
        </div>
        <div class="d-flex justify-content-center">
          <nav aria-label="Page navigation example">
            <ul class="pagination">
              <li class="page-item">
                <a class="page-link" href="#"
                v-if="currentPage > 0" @click="currentPage--"
                aria-label="Previous">
                  <i class="fa fa-angle-left"></i>
                  <span class="sr-only">Anterior</span>
                </a>
              </li>
              <li class="page-item" v-for="page in pages" :key="page">
                <a class="page-link" @click="goToPage(page)"
                href="#">{{ page }}</a>
              </li>
              <li class="page-item">
                <a class="page-link" 
                v-if="currentPage < pageCount - 1" @click="currentPage++"
                href="#" aria-label="Next">
                  <i class="fa fa-angle-right"></i>
                  <span class="sr-only">Siguiente</span>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: "authors-table",
  data: () => ({
    headers: [
      {
        text: "#SKU",
        sortable: true,
        value: "1"
      },
      { text: "Estatus", value: "true" },
      { text: "Producto", value: "PRUEBA" },
      { text: "Precio", value: "001" },
      { text: "Inventario Actual", value: "10" },
      { text: "Inventario Anterior", value: "10" },
      { text: "Fecha de creación", value: "2023-04-12" },
      { text: "Fecha de modificación", value: "2023-04-12" },
      { text: "Imagen", value: "src" }
    ],
    products: [],
    selectedDate: '',
    dates: [],    
    currentPage: 0,
    pageSize: 25,
  }),
  computed: {
    pageCount() {
      return Math.ceil(this.products.length / this.pageSize)
    },
    displayItems() {
      const startIndex = this.currentPage * this.pageSize
      const endIndex = startIndex + this.pageSize
      console.log(this.products.slice(startIndex, endIndex))
      return this.products.slice(startIndex, endIndex)
    },
    pages() {
      const pagesArray = []
      for(let i = 0; i < this.pageCount; i++) {
        pagesArray.push(i)
      }
      return pagesArray
    }
  },
  methods: {
    nextPage() {
      if(this.currentPage < this.pageCount -1)
        this.currentPage++
    },
    prevPage() {
      if(this.currentPage > 0)
        this.currentPage--
    },
    goToPage(page) {
      this.currentPage = page
    },
    loadTable(date) {
      const pad = (num) => {
        return num.toString().padStart(2, '0')
      }
      // const date = new Date();
      const isoString = date.toISOString()
      //time zone offset format
      const timeZoneOffset = date.getTimezoneOffset()
      const offsetHours = Math.abs(Math.floor(timeZoneOffset / 60))
      const offsetMinutes = Math.abs(timeZoneOffset % 60)
      const offsetSign = timeZoneOffset > 0 ? '-': '+'
      //modify iso 8601 format to inclide time zone offset
      const isoStringWithOffset = 
      isoString.slice(0, -1) + offsetSign + pad(offsetHours) + ':' + pad(offsetMinutes)

      // console.log(isoStringWithOffset);
      fetch(`https://admin.xhantae.com/api/shopify/updated?updated_at_min=${isoStringWithOffset}&limit=250`, {
        method: 'GET',
        headers: {
          'Content-Type' : 'application/json'
        },
        redirect : 'follow'
      })
      .then((res) => res.json())
      .then((response) => {
        this.products = this.sortedDate(response)
        // console.log(response);
      })
    },
    handleSelected() {
      this.loadTable(new Date(this.selectedDate))
    },
    sortedDate(products) {
      return products.sort((a,b) => new Date(b.updated_at) - new Date(a.updated_at))
    },
    formatDate(date) {
      if(date) {
        moment.locale('es')
      
        return moment(String(date)).format('LLLL')
      }
    }
  },
  mounted() {
    const today = new Date()
    for(let i = 0; i <= 7; i++) {
      const date = new Date(today.getFullYear(), today.getMonth(), today.getDate() - i)
      const dateString = date.toISOString().split('T')[0]
      this.dates.push(dateString)
    }
  },
  beforeMount() {
    const today = new Date()
    const date = new Date(today.getFullYear(), today.getMonth(), today.getDate())
    this.loadTable(date)
  },
  
};
</script>
